import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  onSearch: (value: string) => void;
}

const MenuSearch: React.FC<Props> = ({ onSearch }) => {
  const { t } = useTranslation();

  return (
    <div className="menu-search d-none d-sm-block">
      <div className="position-relative">
        <input
          type="text"
          className="form-control search-lg"
          placeholder={t("Search menu...")}
          onChange={(e) => onSearch(e.target.value)}
        />
        <span className="bx bx-search-alt">
          <i className="fa fa-fw fa-search"></i>
        </span>
      </div>
    </div>
  );
};

export default MenuSearch;